var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#1F9FF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5156 19.125C34.4531 18.4219 35.2969 17.5781 35.9531 16.5938C35.1094 16.9688 34.125 17.25 33.1406 17.3438C34.1719 16.7344 34.9219 15.7969 35.2969 14.625C34.3594 15.1875 33.2812 15.6094 32.2031 15.8438C31.2656 14.8594 30 14.2969 28.5938 14.2969C25.875 14.2969 23.6719 16.5 23.6719 19.2188C23.6719 19.5938 23.7188 19.9688 23.8125 20.3438C19.7344 20.1094 16.0781 18.1406 13.6406 15.1875C13.2188 15.8906 12.9844 16.7344 12.9844 17.6719C12.9844 19.3594 13.8281 20.8594 15.1875 21.75C14.3906 21.7031 13.5938 21.5156 12.9375 21.1406V21.1875C12.9375 23.5781 14.625 25.5469 16.875 26.0156C16.5 26.1094 16.0312 26.2031 15.6094 26.2031C15.2812 26.2031 15 26.1562 14.6719 26.1094C15.2812 28.0781 17.1094 29.4844 19.2656 29.5312C17.5781 30.8438 15.4688 31.6406 13.1719 31.6406C12.75 31.6406 12.375 31.5938 12 31.5469C14.1562 32.9531 16.7344 33.75 19.5469 33.75C28.5938 33.75 33.5156 26.2969 33.5156 19.7812C33.5156 19.5469 33.5156 19.3594 33.5156 19.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4bf7d95d3bad0b66cc453610e02b83ce.svg";
export { ForwardRef as ReactComponent };